export const handleChangeDataModalLogOutCourier = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_LOG_OUT_COURIER', name, value
});